//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthClient } from '../app/services/authService';
import { getAccessToken } from 'app/utils/authUtilities';
export class CssApiClientBase {
    constructor() { };

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (options.headers) {
            let token = getAccessToken();
            if(token === null) {
                token = await new AuthClient().getToken();
            }
            var headers = options.headers as { [index: string]: string };
            headers['Authorization'] = `Bearer ${token}`;
        }
        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processResponse: (_response: Response) => Promise<any>
    ): Promise<any> {
        try {
            return await processResponse(response);
        } catch (error: any) {
            if(response.ok) {
                return;
            }

            throw new ApiError(
                response.status,
                response.statusText,
                error?.result ?? error
            );
        }
    }
}

export class CssApiClient extends CssApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a Css
     * @return Returns the newly created item id
     */
    cssRequest_CreateCss(css: CssRequestDto): Promise<string> {
        let url_ = this.baseUrl + "/css/CssRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(css);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_CreateCss(_response));
        });
    }

    protected processCssRequest_CreateCss(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update a css
     * @return Returns the newly created item id
     */
    cssRequest_UpdateCss(css: EditRequestDto): Promise<CssRequestDto> {
        let url_ = this.baseUrl + "/css/CssRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(css);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_UpdateCss(_response));
        });
    }

    protected processCssRequest_UpdateCss(response: Response): Promise<CssRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CssRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the CssID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CssRequestDto>(null as any);
    }

    /**
     * Delete the Css
     * @param requestId (optional) The request identifier
     */
    cssRequest_Delete(requestId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/css/CssRequest?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_Delete(_response));
        });
    }

    protected processCssRequest_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Css with pagination
     * @param pageNumber (optional) The page number
     * @param pageSize (optional) Page size
     */
    cssRequest_CssRequests(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfCssRequestDto> {
        let url_ = this.baseUrl + "/css/CssRequest?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_CssRequests(_response));
        });
    }

    protected processCssRequest_CssRequests(response: Response): Promise<PaginatedListOfCssRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCssRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCssRequestDto>(null as any);
    }

    /**
     * Get the Css
     * @param requestId The Guid
     * @return Returns the css item for the ID passed
     */
    cssRequest_GetCssById(requestId: string): Promise<CssRequestDto> {
        let url_ = this.baseUrl + "/css/CssRequest/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_GetCssById(_response));
        });
    }

    protected processCssRequest_GetCssById(response: Response): Promise<CssRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CssRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the CssID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CssRequestDto>(null as any);
    }

    /**
     * Add Customer impact
     * @param id The css identifier
     * @param customerImpact The customer impact
     */
    cssRequest_AddCustomerImpact(id: string, customerImpact: CustomerImpactDto[]): Promise<CustomerImpactResponseDto> {
        let url_ = this.baseUrl + "/css/CssRequest/{id}/AddCustomerImpact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_AddCustomerImpact(_response));
        });
    }

    protected processCssRequest_AddCustomerImpact(response: Response): Promise<CustomerImpactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactResponseDto>(null as any);
    }

    cssRequest_DeleteCustomerImpact(id: string, customerImpact: CustomerImpactDto): Promise<boolean> {
        let url_ = this.baseUrl + "/css/CssRequest/{id}/DeleteCustomerImpact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_DeleteCustomerImpact(_response));
        });
    }

    protected processCssRequest_DeleteCustomerImpact(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Assign user to the request
     * @return True on success
     */
    cssRequest_Assign(assignRequestDto: AssignRequestDto): Promise<void> {
        let url_ = this.baseUrl + "/css/CssRequest/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_Assign(_response));
        });
    }

    protected processCssRequest_Assign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    cssRequest_UpdateParentChild(requestDto: RequestDto): Promise<RequestDto> {
        let url_ = this.baseUrl + "/css/CssRequest/ParentChild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_UpdateParentChild(_response));
        });
    }

    protected processCssRequest_UpdateParentChild(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    cssRequest_CustomerImpactEditSnapshot(id: string, selector: CustomerImpactDto): Promise<CustomerImpactEditSnapshotDto> {
        let url_ = this.baseUrl + "/css/CssRequest/{id}/CustomerImpactEdit/Snapshot";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selector);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_CustomerImpactEditSnapshot(_response));
        });
    }

    protected processCssRequest_CustomerImpactEditSnapshot(response: Response): Promise<CustomerImpactEditSnapshotDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactEditSnapshotDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactEditSnapshotDto>(null as any);
    }

    cssRequest_CustomerImpactEditProjection(id: string, pageSize: number | undefined, continuationToken: string | null | undefined): Promise<CustomerImpactEditProjectionDto> {
        let url_ = this.baseUrl + "/css/CssRequest/{id}/CustomerImpactEdit/Projection?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_CustomerImpactEditProjection(_response));
        });
    }

    protected processCssRequest_CustomerImpactEditProjection(response: Response): Promise<CustomerImpactEditProjectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactEditProjectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactEditProjectionDto>(null as any);
    }

    cssRequest_EditCustomerImpact(id: string, edit: CustomerImpactEditDto): Promise<CustomerImpactEditResultDto> {
        let url_ = this.baseUrl + "/css/CssRequest/{id}/CustomerImpactEdit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(edit);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_EditCustomerImpact(_response));
        });
    }

    protected processCssRequest_EditCustomerImpact(response: Response): Promise<CustomerImpactEditResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactEditResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactEditResultDto>(null as any);
    }

    cssRequest_AddCustomerImpact2(addCustomerImpact: AddCustomerImpactDto): Promise<CustomerImpactResponseDto> {
        let url_ = this.baseUrl + "/css/CssRequest/AddCustomerImpact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addCustomerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_AddCustomerImpact2(_response));
        });
    }

    protected processCssRequest_AddCustomerImpact2(response: Response): Promise<CustomerImpactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactResponseDto>(null as any);
    }

    cssRequest_UpdateWatcher(addWatcherDto: AddWatcherDto): Promise<boolean> {
        let url_ = this.baseUrl + "/css/CssRequest/Watcher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addWatcherDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCssRequest_UpdateWatcher(_response));
        });
    }

    protected processCssRequest_UpdateWatcher(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    home_Index(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/css";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome_Index(_response));
        });
    }

    protected processHome_Index(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get list of Customer Regions
     * @return List of Customer Regions with ID and Name
     */
    lookup_CustomerRegion(): Promise<EnumLookUp[]> {
        let url_ = this.baseUrl + "/css/Lookup/CustomerRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookup_CustomerRegion(_response));
        });
    }

    protected processLookup_CustomerRegion(response: Response): Promise<EnumLookUp[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumLookUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumLookUp[]>(null as any);
    }

    /**
     * Create review Request
     * @param createCssReviewRequest The css review request
     * @return The unified tracking Id
     */
    reviewRequest_CreateCssReviewRequest(createCssReviewRequest: CreateCssReviewRequestDto): Promise<string> {
        let url_ = this.baseUrl + "/css/ReviewRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCssReviewRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_CreateCssReviewRequest(_response));
        });
    }

    protected processReviewRequest_CreateCssReviewRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update a review request
     * @return The update review request
     */
    reviewRequest_UpdateCssReviewRequest(editCssReviewRequest: EditCssReviewRequestDto): Promise<CssReviewRequestDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editCssReviewRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_UpdateCssReviewRequest(_response));
        });
    }

    protected processReviewRequest_UpdateCssReviewRequest(response: Response): Promise<CssReviewRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CssReviewRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CssReviewRequestDto>(null as any);
    }

    /**
     * Get css review request with pagination
     * @param pageNumber (optional) The page number
     * @param pageSize (optional) Page size
     */
    reviewRequest_ReviewRequests(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfCssReviewRequestDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_ReviewRequests(_response));
        });
    }

    protected processReviewRequest_ReviewRequests(response: Response): Promise<PaginatedListOfCssReviewRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCssReviewRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCssReviewRequestDto>(null as any);
    }

    /**
     * Delete review request
     * @param requestId (optional) 
     * @param suppressNotification (optional) Suppress event propogation
     */
    reviewRequest_Delete(requestId: string | null | undefined, suppressNotification: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/css/ReviewRequest?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (suppressNotification !== undefined && suppressNotification !== null)
            url_ += "suppressNotification=" + encodeURIComponent("" + suppressNotification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_Delete(_response));
        });
    }

    protected processReviewRequest_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Request by id
     * @param id The identifier
     */
    reviewRequest_ReviewRequest(id: string): Promise<CssReviewRequestDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_ReviewRequest(_response));
        });
    }

    protected processReviewRequest_ReviewRequest(response: Response): Promise<CssReviewRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CssReviewRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CssReviewRequestDto>(null as any);
    }

    /**
     * Assign user to the request
     * @return True on success
     */
    reviewRequest_Assign(assignRequestDto: AssignRequestDto): Promise<void> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_Assign(_response));
        });
    }

    protected processReviewRequest_Assign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reassign a Request to Css review Request
     */
    reviewRequest_Reassign(reassignDto: RequestDto): Promise<void> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reassignDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_Reassign(_response));
        });
    }

    protected processReviewRequest_Reassign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Customer Impact
     * @param id css identifier
     * @param customerImpact customer impact
     * @return true or false
     */
    reviewRequest_DeleteCustomerImpact(id: string, customerImpact: CustomerImpactDto): Promise<boolean> {
        let url_ = this.baseUrl + "/css/ReviewRequest/{id}/DeleteCustomerImpact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_DeleteCustomerImpact(_response));
        });
    }

    protected processReviewRequest_DeleteCustomerImpact(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Add attachment to a ticket
     * @param addAttachmentDto The attachment dto object
     */
    reviewRequest_AddAttachment(addAttachmentDto: AddAttachmentDto): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addAttachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_AddAttachment(_response));
        });
    }

    protected processReviewRequest_AddAttachment(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    /**
     * Delete Attachment
     * @param entityId (optional) 
     * @param entityType (optional) 
     */
    reviewRequest_DeleteAttachmentById(id: string, entityId: string | null | undefined, entityType: EntityType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Attachment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_DeleteAttachmentById(_response));
        });
    }

    protected processReviewRequest_DeleteAttachmentById(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get all attachments of a request
     * @param entityId (optional) 
     * @param entityType (optional) 
     * @param portal (optional) 
     */
    reviewRequest_GetAttachments(entityId: string | null | undefined, entityType: EntityType | undefined, portal: Portal | undefined): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Attachment/List?";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (portal === null)
            throw new Error("The parameter 'portal' cannot be null.");
        else if (portal !== undefined)
            url_ += "portal=" + encodeURIComponent("" + portal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_GetAttachments(_response));
        });
    }

    protected processReviewRequest_GetAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    /**
     * Update the classification of an attachment
     */
    reviewRequest_UpdateClassification(attachmentDto: UpdateClassificationDto): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Attachment/UpdateClassification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_UpdateClassification(_response));
        });
    }

    protected processReviewRequest_UpdateClassification(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    reviewRequest_UpdateParentChild(requestDto: RequestDto): Promise<RequestDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest/ParentChild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_UpdateParentChild(_response));
        });
    }

    protected processReviewRequest_UpdateParentChild(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    reviewRequest_UpdateDevices(requestDto: RequestDto): Promise<boolean> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_UpdateDevices(_response));
        });
    }

    protected processReviewRequest_UpdateDevices(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Add Hash Tags
     * @param id SKP-ID
     * @param hashTags HashTags
     */
    reviewRequest_AddHashTags(id: string, hashTags: HashTagDto[]): Promise<boolean> {
        let url_ = this.baseUrl + "/css/ReviewRequest/{id}/AddHashTags";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hashTags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_AddHashTags(_response));
        });
    }

    protected processReviewRequest_AddHashTags(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    reviewRequest_CustomerImpactEditSnapshot(id: string, selector: CustomerImpactDto): Promise<CustomerImpactEditSnapshotDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest/{id}/CustomerImpactEdit/Snapshot";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selector);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_CustomerImpactEditSnapshot(_response));
        });
    }

    protected processReviewRequest_CustomerImpactEditSnapshot(response: Response): Promise<CustomerImpactEditSnapshotDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactEditSnapshotDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactEditSnapshotDto>(null as any);
    }

    reviewRequest_CustomerImpactEditProjection(id: string, pageSize: number | undefined, continuationToken: string | null | undefined): Promise<CustomerImpactEditProjectionDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest/{id}/CustomerImpactEdit/Projection?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_CustomerImpactEditProjection(_response));
        });
    }

    protected processReviewRequest_CustomerImpactEditProjection(response: Response): Promise<CustomerImpactEditProjectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactEditProjectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactEditProjectionDto>(null as any);
    }

    reviewRequest_EditCustomerImpact(id: string, edit: CustomerImpactEditDto): Promise<CustomerImpactEditResultDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest/{id}/CustomerImpactEdit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(edit);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_EditCustomerImpact(_response));
        });
    }

    protected processReviewRequest_EditCustomerImpact(response: Response): Promise<CustomerImpactEditResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactEditResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactEditResultDto>(null as any);
    }

    reviewRequest_AddCustomerImpact(addCustomerImpact: AddCustomerImpactDto): Promise<CustomerImpactResponseDto> {
        let url_ = this.baseUrl + "/css/ReviewRequest/AddCustomerImpact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addCustomerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_AddCustomerImpact(_response));
        });
    }

    protected processReviewRequest_AddCustomerImpact(response: Response): Promise<CustomerImpactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactResponseDto>(null as any);
    }

    reviewRequest_UpdateWatcher(addWatcherDto: AddWatcherDto): Promise<boolean> {
        let url_ = this.baseUrl + "/css/ReviewRequest/Watcher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addWatcherDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewRequest_UpdateWatcher(_response));
        });
    }

    protected processReviewRequest_UpdateWatcher(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class BaseRequestDto implements IBaseRequestDto {
    id?: string;
    whyThisDateIsImportant?: string | undefined;
    unifiedTrackingId?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    closedOn?: Date | undefined;
    description?: string | undefined;
    confidentialIdentifier?: string | undefined;
    escalationReason?: string | undefined;
    warrantyHelpType?: string | undefined;
    warrantyAdditionalDetails?: string | undefined;
    businessConsequence?: string | undefined;
    customersPayMore?: string | undefined;
    estimatedPriceUplift?: string | undefined;
    keyCompetitors?: string | undefined;
    feedbackSource?: string | undefined;
    feedbackSourceDetails?: string | undefined;
    submittedViaNewFlow?: boolean;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    watchers?: UserDto[] | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    totalDeviceCount?: number;
    totalRevenue?: number;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number;
    msxCurrentTotalDeviceCount?: number;
    reasonForReassignment?: number | undefined;
    assignee?: UserDto | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    isParent?: boolean | undefined;
    childrenCount?: number | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    originalRoutingML?: boolean | undefined;
    isActive?: boolean;

    constructor(data?: IBaseRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
            this.unifiedTrackingId = _data["unifiedTrackingId"];
            this.status = _data["status"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.actualResolutionDate = _data["actualResolutionDate"] ? new Date(_data["actualResolutionDate"].toString()) : <any>undefined;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.confidentialIdentifier = _data["confidentialIdentifier"];
            this.escalationReason = _data["escalationReason"];
            this.warrantyHelpType = _data["warrantyHelpType"];
            this.warrantyAdditionalDetails = _data["warrantyAdditionalDetails"];
            this.businessConsequence = _data["businessConsequence"];
            this.customersPayMore = _data["customersPayMore"];
            this.estimatedPriceUplift = _data["estimatedPriceUplift"];
            this.keyCompetitors = _data["keyCompetitors"];
            this.feedbackSource = _data["feedbackSource"];
            this.feedbackSourceDetails = _data["feedbackSourceDetails"];
            this.submittedViaNewFlow = _data["submittedViaNewFlow"];
            this.customerFamilySubmissionId = _data["customerFamilySubmissionId"];
            this.customerFamilyGeneration = _data["customerFamilyGeneration"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["customerImpacts"])) {
                this.customerImpacts = [] as any;
                for (let item of _data["customerImpacts"])
                    this.customerImpacts!.push(CustomerImpactDto.fromJS(item));
            }
            if (Array.isArray(_data["watchers"])) {
                this.watchers = [] as any;
                for (let item of _data["watchers"])
                    this.watchers!.push(UserDto.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.totalDeviceCount = _data["totalDeviceCount"];
            this.totalRevenue = _data["totalRevenue"];
            this.msxTotalRevenue = _data["msxTotalRevenue"];
            this.msxTotalDeviceCount = _data["msxTotalDeviceCount"];
            this.msxCurrentTotalRevenue = _data["msxCurrentTotalRevenue"];
            this.msxCurrentTotalDeviceCount = _data["msxCurrentTotalDeviceCount"];
            this.reasonForReassignment = _data["reasonForReassignment"];
            this.assignee = _data["assignee"] ? UserDto.fromJS(_data["assignee"]) : <any>undefined;
            this.companyInformation = _data["companyInformation"] ? CompanyInformationDto.fromJS(_data["companyInformation"]) : <any>undefined;
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
            if (Array.isArray(_data["hashTags"])) {
                this.hashTags = [] as any;
                for (let item of _data["hashTags"])
                    this.hashTags!.push(HashTagDto.fromJS(item));
            }
            this.isParent = _data["isParent"];
            this.childrenCount = _data["childrenCount"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestDatabaseId = _data["parentRequestDatabaseId"];
            this.originalRoutingML = _data["originalRoutingML"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BaseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        data["unifiedTrackingId"] = this.unifiedTrackingId;
        data["status"] = this.status;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["actualResolutionDate"] = this.actualResolutionDate ? this.actualResolutionDate.toISOString() : <any>undefined;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["confidentialIdentifier"] = this.confidentialIdentifier;
        data["escalationReason"] = this.escalationReason;
        data["warrantyHelpType"] = this.warrantyHelpType;
        data["warrantyAdditionalDetails"] = this.warrantyAdditionalDetails;
        data["businessConsequence"] = this.businessConsequence;
        data["customersPayMore"] = this.customersPayMore;
        data["estimatedPriceUplift"] = this.estimatedPriceUplift;
        data["keyCompetitors"] = this.keyCompetitors;
        data["feedbackSource"] = this.feedbackSource;
        data["feedbackSourceDetails"] = this.feedbackSourceDetails;
        data["submittedViaNewFlow"] = this.submittedViaNewFlow;
        data["customerFamilySubmissionId"] = this.customerFamilySubmissionId;
        data["customerFamilyGeneration"] = this.customerFamilyGeneration;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.customerImpacts)) {
            data["customerImpacts"] = [];
            for (let item of this.customerImpacts)
                data["customerImpacts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.watchers)) {
            data["watchers"] = [];
            for (let item of this.watchers)
                data["watchers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["totalDeviceCount"] = this.totalDeviceCount;
        data["totalRevenue"] = this.totalRevenue;
        data["msxTotalRevenue"] = this.msxTotalRevenue;
        data["msxTotalDeviceCount"] = this.msxTotalDeviceCount;
        data["msxCurrentTotalRevenue"] = this.msxCurrentTotalRevenue;
        data["msxCurrentTotalDeviceCount"] = this.msxCurrentTotalDeviceCount;
        data["reasonForReassignment"] = this.reasonForReassignment;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["companyInformation"] = this.companyInformation ? this.companyInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hashTags)) {
            data["hashTags"] = [];
            for (let item of this.hashTags)
                data["hashTags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isParent"] = this.isParent;
        data["childrenCount"] = this.childrenCount;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestDatabaseId"] = this.parentRequestDatabaseId;
        data["originalRoutingML"] = this.originalRoutingML;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBaseRequestDto {
    id?: string;
    whyThisDateIsImportant?: string | undefined;
    unifiedTrackingId?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    closedOn?: Date | undefined;
    description?: string | undefined;
    confidentialIdentifier?: string | undefined;
    escalationReason?: string | undefined;
    warrantyHelpType?: string | undefined;
    warrantyAdditionalDetails?: string | undefined;
    businessConsequence?: string | undefined;
    customersPayMore?: string | undefined;
    estimatedPriceUplift?: string | undefined;
    keyCompetitors?: string | undefined;
    feedbackSource?: string | undefined;
    feedbackSourceDetails?: string | undefined;
    submittedViaNewFlow?: boolean;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    watchers?: UserDto[] | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    totalDeviceCount?: number;
    totalRevenue?: number;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number;
    msxCurrentTotalDeviceCount?: number;
    reasonForReassignment?: number | undefined;
    assignee?: UserDto | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    isParent?: boolean | undefined;
    childrenCount?: number | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    originalRoutingML?: boolean | undefined;
    isActive?: boolean;
}

export class CssRequestDto extends BaseRequestDto implements ICssRequestDto {
    summary?: string | undefined;
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    deviceModel?: DeviceModelDto | undefined;
    actionRequired?: string | undefined;
    email?: string | undefined;
    bugInformations?: BugInformations[] | undefined;

    constructor(data?: ICssRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.companyRegion = _data["companyRegion"];
            this.companyContactName = _data["companyContactName"];
            this.deviceModel = _data["deviceModel"] ? DeviceModelDto.fromJS(_data["deviceModel"]) : <any>undefined;
            this.actionRequired = _data["actionRequired"];
            this.email = _data["email"];
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformations.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CssRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CssRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["companyRegion"] = this.companyRegion;
        data["companyContactName"] = this.companyContactName;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : <any>undefined;
        data["actionRequired"] = this.actionRequired;
        data["email"] = this.email;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICssRequestDto extends IBaseRequestDto {
    summary?: string | undefined;
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    deviceModel?: DeviceModelDto | undefined;
    actionRequired?: string | undefined;
    email?: string | undefined;
    bugInformations?: BugInformations[] | undefined;
}

export enum CompanyRegion {
    AOC = 1,
    EMEA = 2,
    APAC = 3,
    LATAM = 4,
    Global = 5,
}

export class DeviceModelDto implements IDeviceModelDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    count?: number | undefined;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;

    constructor(data?: IDeviceModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.deviceCount = _data["deviceCount"];
            this.count = _data["count"];
            this.iconUrl = _data["iconUrl"];
            this.isAdded = _data["isAdded"];
        }
    }

    static fromJS(data: any): DeviceModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["deviceCount"] = this.deviceCount;
        data["count"] = this.count;
        data["iconUrl"] = this.iconUrl;
        data["isAdded"] = this.isAdded;
        return data;
    }
}

export interface IDeviceModelDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    count?: number | undefined;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;
}

export class BugInformations implements IBugInformations {
    bugInformation?: BugInformation;
    url?: string | undefined;

    constructor(data?: IBugInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bugInformation = _data["bugInformation"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BugInformations {
        data = typeof data === 'object' ? data : {};
        let result = new BugInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bugInformation"] = this.bugInformation;
        data["url"] = this.url;
        return data;
    }
}

export interface IBugInformations {
    bugInformation?: BugInformation;
    url?: string | undefined;
}

export enum BugInformation {
    PLE_Bug = 1,
    MSFT_Devices_Non_PLE_Bug = 2,
    OS_Bug = 3,
    Hub_OS_Bug = 4,
    Other_Bugs = 5,
    Azure_Devops_Link = 6,
}

export enum RequestStatus {
    New = 1,
    Active = 2,
    InProgress = 3,
    Resolved = 4,
    Closed = 5,
}

export class AttachmentDto implements IAttachmentDto {
    id?: string;
    url?: string | undefined;
    fileName?: string | undefined;
    blobFileName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    isExternal?: boolean;
    etag?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.blobFileName = _data["blobFileName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.isExternal = _data["isExternal"];
            this.etag = _data["etag"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["blobFileName"] = this.blobFileName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["isExternal"] = this.isExternal;
        data["etag"] = this.etag;
        return data;
    }
}

export interface IAttachmentDto {
    id?: string;
    url?: string | undefined;
    fileName?: string | undefined;
    blobFileName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    isExternal?: boolean;
    etag?: string | undefined;
}

export class UserDto implements IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.userDomain = _data["userDomain"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.contactNumber = _data["contactNumber"];
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["userDomain"] = this.userDomain;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["contactNumber"] = this.contactNumber;
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;
}

export enum RequestDomain {
    SDSG = 1,
    CXP = 2,
    CSS = 3,
    Crew = 4,
    Admin = 5,
}

export class UserRole implements IUserRole {
    roleName?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRole {
    roleName?: string | undefined;
}

export class CustomerImpactDto implements ICustomerImpactDto {
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    accountId?: string | undefined;
    customerName?: string | undefined;
    customerImpactDescription?: string | undefined;
    requestDescription?: string | undefined;
    cssCaseNumber?: string | undefined;
    isSameAsTicket?: boolean;
    customerCountry?: CountryDto | undefined;
    msxOpportunityId?: string | undefined;
    deviceCount?: number | undefined;
    revenue?: number | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    addedOn?: Date;
    addedBy?: UserDto | undefined;
    editedOn?: Date | undefined;
    editedBy?: string | undefined;
    editId?: string | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: ICustomerImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.tpId = _data["tpId"];
            this.accountId = _data["accountId"];
            this.customerName = _data["customerName"];
            this.customerImpactDescription = _data["customerImpactDescription"];
            this.requestDescription = _data["requestDescription"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.isSameAsTicket = _data["isSameAsTicket"];
            this.customerCountry = _data["customerCountry"] ? CountryDto.fromJS(_data["customerCountry"]) : <any>undefined;
            this.msxOpportunityId = _data["msxOpportunityId"];
            this.deviceCount = _data["deviceCount"];
            this.revenue = _data["revenue"];
            this.msxDeviceCount = _data["msxDeviceCount"];
            this.msxRevenue = _data["msxRevenue"];
            this.msxCurrentDeviceCount = _data["msxCurrentDeviceCount"];
            this.msxCurrentRevenue = _data["msxCurrentRevenue"];
            this.msxInfoUpdatedOn = _data["msxInfoUpdatedOn"] ? new Date(_data["msxInfoUpdatedOn"].toString()) : <any>undefined;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
            this.addedBy = _data["addedBy"] ? UserDto.fromJS(_data["addedBy"]) : <any>undefined;
            this.editedOn = _data["editedOn"] ? new Date(_data["editedOn"].toString()) : <any>undefined;
            this.editedBy = _data["editedBy"];
            this.editId = _data["editId"];
            this.endCustomerSegment = _data["endCustomerSegment"];
            this.competitor = _data["competitor"];
            this.salesPlay = _data["salesPlay"];
            this.refreshYourDevice = _data["refreshYourDevice"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): CustomerImpactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["tpId"] = this.tpId;
        data["accountId"] = this.accountId;
        data["customerName"] = this.customerName;
        data["customerImpactDescription"] = this.customerImpactDescription;
        data["requestDescription"] = this.requestDescription;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["isSameAsTicket"] = this.isSameAsTicket;
        data["customerCountry"] = this.customerCountry ? this.customerCountry.toJSON() : <any>undefined;
        data["msxOpportunityId"] = this.msxOpportunityId;
        data["deviceCount"] = this.deviceCount;
        data["revenue"] = this.revenue;
        data["msxDeviceCount"] = this.msxDeviceCount;
        data["msxRevenue"] = this.msxRevenue;
        data["msxCurrentDeviceCount"] = this.msxCurrentDeviceCount;
        data["msxCurrentRevenue"] = this.msxCurrentRevenue;
        data["msxInfoUpdatedOn"] = this.msxInfoUpdatedOn ? this.msxInfoUpdatedOn.toISOString() : <any>undefined;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : <any>undefined;
        data["editedOn"] = this.editedOn ? this.editedOn.toISOString() : <any>undefined;
        data["editedBy"] = this.editedBy;
        data["editId"] = this.editId;
        data["endCustomerSegment"] = this.endCustomerSegment;
        data["competitor"] = this.competitor;
        data["salesPlay"] = this.salesPlay;
        data["refreshYourDevice"] = this.refreshYourDevice;
        data["status"] = this.status;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface ICustomerImpactDto {
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    accountId?: string | undefined;
    customerName?: string | undefined;
    customerImpactDescription?: string | undefined;
    requestDescription?: string | undefined;
    cssCaseNumber?: string | undefined;
    isSameAsTicket?: boolean;
    customerCountry?: CountryDto | undefined;
    msxOpportunityId?: string | undefined;
    deviceCount?: number | undefined;
    revenue?: number | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    addedOn?: Date;
    addedBy?: UserDto | undefined;
    editedOn?: Date | undefined;
    editedBy?: string | undefined;
    editId?: string | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export class CountryDto implements ICountryDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryDto {
    id?: number;
    name?: string | undefined;
}

export class CompanyInformationDto implements ICompanyInformationDto {
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    alternateContactNumber?: string | undefined;

    constructor(data?: ICompanyInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRegion = _data["companyRegion"];
            this.companyContactName = _data["companyContactName"];
            this.companyFullShippingAddress = _data["companyFullShippingAddress"];
            this.companyName = _data["companyName"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.country = _data["country"];
            this.alternateContactNumber = _data["alternateContactNumber"];
        }
    }

    static fromJS(data: any): CompanyInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegion"] = this.companyRegion;
        data["companyContactName"] = this.companyContactName;
        data["companyFullShippingAddress"] = this.companyFullShippingAddress;
        data["companyName"] = this.companyName;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["country"] = this.country;
        data["alternateContactNumber"] = this.alternateContactNumber;
        return data;
    }
}

export interface ICompanyInformationDto {
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    alternateContactNumber?: string | undefined;
}

export class HashTagDto implements IHashTagDto {
    hashTag?: string | undefined;

    constructor(data?: IHashTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashTag = _data["hashTag"];
        }
    }

    static fromJS(data: any): HashTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new HashTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashTag"] = this.hashTag;
        return data;
    }
}

export interface IHashTagDto {
    hashTag?: string | undefined;
}

export class EditRequestDto implements IEditRequestDto {
    id?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    closedOn?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;

    constructor(data?: IEditRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.companyInformation = _data["companyInformation"] ? CompanyInformationDto.fromJS(_data["companyInformation"]) : <any>undefined;
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
            if (Array.isArray(_data["hashTags"])) {
                this.hashTags = [] as any;
                for (let item of _data["hashTags"])
                    this.hashTags!.push(HashTagDto.fromJS(item));
            }
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.actualResolutionDate = _data["actualResolutionDate"] ? new Date(_data["actualResolutionDate"].toString()) : <any>undefined;
            this.customerFamilySubmissionId = _data["customerFamilySubmissionId"];
            this.customerFamilyGeneration = _data["customerFamilyGeneration"];
        }
    }

    static fromJS(data: any): EditRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["status"] = this.status;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["companyInformation"] = this.companyInformation ? this.companyInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hashTags)) {
            data["hashTags"] = [];
            for (let item of this.hashTags)
                data["hashTags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["actualResolutionDate"] = this.actualResolutionDate ? this.actualResolutionDate.toISOString() : <any>undefined;
        data["customerFamilySubmissionId"] = this.customerFamilySubmissionId;
        data["customerFamilyGeneration"] = this.customerFamilyGeneration;
        return data;
    }
}

export interface IEditRequestDto {
    id?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    closedOn?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
}

export class PaginatedListOfCssRequestDto implements IPaginatedListOfCssRequestDto {
    items?: CssRequestDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCssRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CssRequestDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCssRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCssRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCssRequestDto {
    items?: CssRequestDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CustomerImpactResponseDto implements ICustomerImpactResponseDto {
    id?: string | undefined;
    originalRequestId?: string | undefined;
    parentRequestId?: string | undefined;
    parentCreated?: boolean;
    outcomes?: CustomerImpactOutcomeDto[] | undefined;

    constructor(data?: ICustomerImpactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalRequestId = _data["originalRequestId"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentCreated = _data["parentCreated"];
            if (Array.isArray(_data["outcomes"])) {
                this.outcomes = [] as any;
                for (let item of _data["outcomes"])
                    this.outcomes!.push(CustomerImpactOutcomeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerImpactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalRequestId"] = this.originalRequestId;
        data["parentRequestId"] = this.parentRequestId;
        data["parentCreated"] = this.parentCreated;
        if (Array.isArray(this.outcomes)) {
            data["outcomes"] = [];
            for (let item of this.outcomes)
                data["outcomes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICustomerImpactResponseDto {
    id?: string | undefined;
    originalRequestId?: string | undefined;
    parentRequestId?: string | undefined;
    parentCreated?: boolean;
    outcomes?: CustomerImpactOutcomeDto[] | undefined;
}

export class CustomerImpactOutcomeDto implements ICustomerImpactOutcomeDto {
    customerName?: string | undefined;
    requestId?: string | undefined;
    action?: string | undefined;
    requestedResolutionDate?: Date | undefined;
    attachmentTarget?: string | undefined;

    constructor(data?: ICustomerImpactOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.requestId = _data["requestId"];
            this.action = _data["action"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.attachmentTarget = _data["attachmentTarget"];
        }
    }

    static fromJS(data: any): CustomerImpactOutcomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactOutcomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["requestId"] = this.requestId;
        data["action"] = this.action;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["attachmentTarget"] = this.attachmentTarget;
        return data;
    }
}

export interface ICustomerImpactOutcomeDto {
    customerName?: string | undefined;
    requestId?: string | undefined;
    action?: string | undefined;
    requestedResolutionDate?: Date | undefined;
    attachmentTarget?: string | undefined;
}

export class AssignRequestDto implements IAssignRequestDto {
    id?: string | undefined;
    assignee?: UserDto | undefined;
    ccUsers?: UserDto[] | undefined;
    assigneeNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IAssignRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignee = _data["assignee"] ? UserDto.fromJS(_data["assignee"]) : <any>undefined;
            if (Array.isArray(_data["ccUsers"])) {
                this.ccUsers = [] as any;
                for (let item of _data["ccUsers"])
                    this.ccUsers!.push(UserDto.fromJS(item));
            }
            this.assigneeNote = _data["assigneeNote"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        if (Array.isArray(this.ccUsers)) {
            data["ccUsers"] = [];
            for (let item of this.ccUsers)
                data["ccUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["assigneeNote"] = this.assigneeNote;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAssignRequestDto {
    id?: string | undefined;
    assignee?: UserDto | undefined;
    ccUsers?: UserDto[] | undefined;
    assigneeNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class RequestDto extends BaseRequestDto implements IRequestDto {
    summary?: string | undefined;
    isHidden?: boolean;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    customerType?: CrewCustomerType | undefined;
    actionRequired?: string | undefined;
    additionalContact?: AdditionalContactDto | undefined;
    requestActionTakenByCss?: string | undefined;
    isDcfRequest?: boolean | undefined;
    dcfJustification?: string | undefined;
    dealInfluenced?: boolean | undefined;
    closingSummary?: string | undefined;
    cssCaseNumber?: string | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    serialNumbersAttached?: boolean | undefined;
    isBookmarked?: boolean;
    priorityNumber?: number | undefined;
    criticality?: Criticality | undefined;
    impactReach?: ImpactReach | undefined;
    productCategory?: ProductCategory | undefined;
    approvedMessaging?: string | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    competitiveOffering?: string | undefined;
    isDesignForSurfacedPossible?: string | undefined;
    pfrSubType?: PFRSubtype | undefined;
    bugInformations?: BugInformations[] | undefined;
    bugNumber?: string | undefined;
    priority?: Priority | undefined;
    caseCodeInvestigation?: CaseCodeInvestigation | undefined;
    caseCodeRequest?: CaseCodeRequest | undefined;
    mainRequestType?: MainRequestType | undefined;
    subRequestType?: SubRequestType | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    dcfApprovedValue?: number | undefined;
    dcfSR?: string | undefined;
    answer?: string | undefined;
    backendId?: string | undefined;
    backendUrl?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    tags?: TagDto[] | undefined;
    selected?: any | undefined;

    constructor(data?: IRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.isHidden = _data["isHidden"];
            this.requestType = _data["requestType"];
            this.requestTeam = _data["requestTeam"];
            this.customerType = _data["customerType"];
            this.actionRequired = _data["actionRequired"];
            this.additionalContact = _data["additionalContact"] ? AdditionalContactDto.fromJS(_data["additionalContact"]) : <any>undefined;
            this.requestActionTakenByCss = _data["requestActionTakenByCss"];
            this.isDcfRequest = _data["isDcfRequest"];
            this.dcfJustification = _data["dcfJustification"];
            this.dealInfluenced = _data["dealInfluenced"];
            this.closingSummary = _data["closingSummary"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.proofOfPurchaseAttached = _data["proofOfPurchaseAttached"];
            this.serialNumbersAttached = _data["serialNumbersAttached"];
            this.isBookmarked = _data["isBookmarked"];
            this.priorityNumber = _data["priorityNumber"];
            this.criticality = _data["criticality"];
            this.impactReach = _data["impactReach"];
            this.productCategory = _data["productCategory"];
            this.approvedMessaging = _data["approvedMessaging"];
            this.whatBusinessProblemIsSolved = _data["whatBusinessProblemIsSolved"];
            this.competitiveOffering = _data["competitiveOffering"];
            this.isDesignForSurfacedPossible = _data["isDesignForSurfacedPossible"];
            this.pfrSubType = _data["pfrSubType"];
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformations.fromJS(item));
            }
            this.bugNumber = _data["bugNumber"];
            this.priority = _data["priority"];
            this.caseCodeInvestigation = _data["caseCodeInvestigation"];
            this.caseCodeRequest = _data["caseCodeRequest"];
            this.mainRequestType = _data["mainRequestType"];
            this.subRequestType = _data["subRequestType"];
            this.isBlockingSale = _data["isBlockingSale"];
            this.isDcfApproved = _data["isDcfApproved"];
            this.dcfApprovedValue = _data["dcfApprovedValue"];
            this.dcfSR = _data["dcfSR"];
            this.answer = _data["answer"];
            this.backendId = _data["backendId"];
            this.backendUrl = _data["backendUrl"];
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static override fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["isHidden"] = this.isHidden;
        data["requestType"] = this.requestType;
        data["requestTeam"] = this.requestTeam;
        data["customerType"] = this.customerType;
        data["actionRequired"] = this.actionRequired;
        data["additionalContact"] = this.additionalContact ? this.additionalContact.toJSON() : <any>undefined;
        data["requestActionTakenByCss"] = this.requestActionTakenByCss;
        data["isDcfRequest"] = this.isDcfRequest;
        data["dcfJustification"] = this.dcfJustification;
        data["dealInfluenced"] = this.dealInfluenced;
        data["closingSummary"] = this.closingSummary;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["proofOfPurchaseAttached"] = this.proofOfPurchaseAttached;
        data["serialNumbersAttached"] = this.serialNumbersAttached;
        data["isBookmarked"] = this.isBookmarked;
        data["priorityNumber"] = this.priorityNumber;
        data["criticality"] = this.criticality;
        data["impactReach"] = this.impactReach;
        data["productCategory"] = this.productCategory;
        data["approvedMessaging"] = this.approvedMessaging;
        data["whatBusinessProblemIsSolved"] = this.whatBusinessProblemIsSolved;
        data["competitiveOffering"] = this.competitiveOffering;
        data["isDesignForSurfacedPossible"] = this.isDesignForSurfacedPossible;
        data["pfrSubType"] = this.pfrSubType;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["bugNumber"] = this.bugNumber;
        data["priority"] = this.priority;
        data["caseCodeInvestigation"] = this.caseCodeInvestigation;
        data["caseCodeRequest"] = this.caseCodeRequest;
        data["mainRequestType"] = this.mainRequestType;
        data["subRequestType"] = this.subRequestType;
        data["isBlockingSale"] = this.isBlockingSale;
        data["isDcfApproved"] = this.isDcfApproved;
        data["dcfApprovedValue"] = this.dcfApprovedValue;
        data["dcfSR"] = this.dcfSR;
        data["answer"] = this.answer;
        data["backendId"] = this.backendId;
        data["backendUrl"] = this.backendUrl;
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["selected"] = this.selected;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestDto extends IBaseRequestDto {
    summary?: string | undefined;
    isHidden?: boolean;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    customerType?: CrewCustomerType | undefined;
    actionRequired?: string | undefined;
    additionalContact?: AdditionalContactDto | undefined;
    requestActionTakenByCss?: string | undefined;
    isDcfRequest?: boolean | undefined;
    dcfJustification?: string | undefined;
    dealInfluenced?: boolean | undefined;
    closingSummary?: string | undefined;
    cssCaseNumber?: string | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    serialNumbersAttached?: boolean | undefined;
    isBookmarked?: boolean;
    priorityNumber?: number | undefined;
    criticality?: Criticality | undefined;
    impactReach?: ImpactReach | undefined;
    productCategory?: ProductCategory | undefined;
    approvedMessaging?: string | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    competitiveOffering?: string | undefined;
    isDesignForSurfacedPossible?: string | undefined;
    pfrSubType?: PFRSubtype | undefined;
    bugInformations?: BugInformations[] | undefined;
    bugNumber?: string | undefined;
    priority?: Priority | undefined;
    caseCodeInvestigation?: CaseCodeInvestigation | undefined;
    caseCodeRequest?: CaseCodeRequest | undefined;
    mainRequestType?: MainRequestType | undefined;
    subRequestType?: SubRequestType | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    dcfApprovedValue?: number | undefined;
    dcfSR?: string | undefined;
    answer?: string | undefined;
    backendId?: string | undefined;
    backendUrl?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    tags?: TagDto[] | undefined;
    selected?: any | undefined;
}

export enum RequestType {
    Proposal = 1,
    Question = 2,
    Rfx = 3,
    PreSales = 4,
    PostSales = 5,
    CSSRequest = 6,
    CssReviewRequest = 7,
    CXP_VariantRequest = 8,
    CXP_PFR_Request = 9,
    CXP_MessagingRequest = 10,
    CXP_TechnicalRequest = 11,
    CXP_ProgramRequest = 12,
    CREW_WarrantyRequest = 13,
    CREW_ProductRequest = 14,
    CREW_MessagingRequest = 15,
}

export enum CrewCustomerType {
    Business_Enterprise_Customer = 1,
    EDU_Customer = 2,
    GOV_Customer = 3,
}

export class AdditionalContactDto implements IAdditionalContactDto {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;

    constructor(data?: IAdditionalContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalShippingAddress = _data["additionalShippingAddress"];
            this.additionalEmailAddress = _data["additionalEmailAddress"];
            this.additionalPhoneNumber = _data["additionalPhoneNumber"];
        }
    }

    static fromJS(data: any): AdditionalContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalShippingAddress"] = this.additionalShippingAddress;
        data["additionalEmailAddress"] = this.additionalEmailAddress;
        data["additionalPhoneNumber"] = this.additionalPhoneNumber;
        return data;
    }
}

export interface IAdditionalContactDto {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;
}

export enum Criticality {
    Zero = 1,
    Fifty = 2,
    OneHundred = 3,
    TwoHundred = 4,
}

export enum ImpactReach {
    Exec_CAB = 1,
    Global = 2,
    No = 3,
}

export enum ProductCategory {
    Hardware = 1,
    Software = 2,
    Other = 3,
    Expirience = 4,
    Policy = 5,
    Warranty = 6,
    ProductFamily = 7,
}

export enum PFRSubtype {
    Emerging_PFR = 1,
    Priority_PFR = 2,
}

export enum Priority {
    High = 1,
    Medium = 2,
    Low = 3,
}

export enum CaseCodeInvestigation {
    CoverageDetails = 1,
    FeedbackSuggestion = 2,
    Operational_SLA = 3,
    Process_Or_PolicyFailure_Limitation = 4,
    Proper_Process_Not_Followed = 5,
    ReverseLogistics = 6,
    RRT_Scenario = 7,
    Surface_Help_Request = 8,
}

export enum CaseCodeRequest {
    FortyFiveDayException = 1,
    ASKU = 2,
    BulkOrder_Or_Exchange = 3,
    DOA_Exception = 4,
    DocumentationRequest = 5,
    GeneralException = 6,
    InvoiceDispute = 7,
    Missing_ADP_Or_EHS = 8,
    NotAvailable = 9,
    Other = 10,
    ProductQuality_Or_PLE = 11,
    ScreenFlicker = 12,
    SwollenBattery = 13,
    WA_Date_Correction = 14,
    WA_Deployment_Date_Adjustment = 15,
    WarrantyReport = 16,
    WrongAutoPilot_Or_InTuneRegistration = 17,
    ExchangeHistory = 18,
}

export enum MainRequestType {
    Exceptions = 1,
    Experience_Or_Offers = 2,
    Reporting = 3,
    Process_Or_PolicyFailure = 4,
    Process_Not_Followed = 5,
    Other = 6,
}

export enum SubRequestType {
    FortyFiveDayException = 1,
    ASKURequest = 2,
    BulkOrder_Or_ExchangeRequest = 3,
    BulkShipping_Or_PickUp = 4,
    OutOfWarranty = 5,
    SwollenBattery = 6,
    DCFGeneralRequest = 7,
    WA_DeploymentDateRequest = 8,
    EPP_PricingChange = 9,
    New_EPP_OfferType = 10,
    NewSupportExperiences = 11,
    OfferExpansion_NewMarket = 12,
    ExchangeHistory = 13,
    WarrantyStatusReport = 14,
    InvoiceDispute = 15,
    Missing_EPP_AfterExchange = 16,
    MissingShippingLabel = 17,
    WA_DateCorrection = 18,
    EPP_didnot_attach_via_MSOnline = 19,
    EPP_didnot_attach_via_MSBnM = 20,
    WA_DateDelay = 21,
    EPP_didnot_attach_OtherRetailer = 22,
    Partner_Didnot_Register = 23,
    ReturnWrongUnit = 24,
    Unit_Not_Returned = 25,
    Other = 26,
}

export enum TaskStatus {
    Consumer = 1,
    Duplicate = 2,
    Following_Or_NoAction = 3,
    FrontlineSupport = 4,
    FrontlineSupport_T2 = 5,
    InvalidRequest = 6,
    NonTechnical = 7,
    SEE_Takeover = 8,
}

export class TagDto implements ITagDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    id?: string;
    name?: string | undefined;
}

export class CustomerImpactEditSnapshotDto implements ICustomerImpactEditSnapshotDto {
    version?: string | undefined;
    originalFingerprint?: string | undefined;
    impact?: CustomerImpactDto | undefined;
    isSameAsTicket?: boolean | undefined;

    constructor(data?: ICustomerImpactEditSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.originalFingerprint = _data["originalFingerprint"];
            this.impact = _data["impact"] ? CustomerImpactDto.fromJS(_data["impact"]) : <any>undefined;
            this.isSameAsTicket = _data["isSameAsTicket"];
        }
    }

    static fromJS(data: any): CustomerImpactEditSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactEditSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["originalFingerprint"] = this.originalFingerprint;
        data["impact"] = this.impact ? this.impact.toJSON() : <any>undefined;
        data["isSameAsTicket"] = this.isSameAsTicket;
        return data;
    }
}

export interface ICustomerImpactEditSnapshotDto {
    version?: string | undefined;
    originalFingerprint?: string | undefined;
    impact?: CustomerImpactDto | undefined;
    isSameAsTicket?: boolean | undefined;
}

export class CustomerImpactEditProjectionDto implements ICustomerImpactEditProjectionDto {
    ownerId?: string;
    requestId?: string | undefined;
    edits?: CustomerImpactEditEventDto[] | undefined;
    continuationToken?: string | undefined;

    constructor(data?: ICustomerImpactEditProjectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.requestId = _data["requestId"];
            if (Array.isArray(_data["edits"])) {
                this.edits = [] as any;
                for (let item of _data["edits"])
                    this.edits!.push(CustomerImpactEditEventDto.fromJS(item));
            }
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): CustomerImpactEditProjectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactEditProjectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["requestId"] = this.requestId;
        if (Array.isArray(this.edits)) {
            data["edits"] = [];
            for (let item of this.edits)
                data["edits"].push(item ? item.toJSON() : <any>undefined);
        }
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface ICustomerImpactEditProjectionDto {
    ownerId?: string;
    requestId?: string | undefined;
    edits?: CustomerImpactEditEventDto[] | undefined;
    continuationToken?: string | undefined;
}

export class CustomerImpactEditEventDto implements ICustomerImpactEditEventDto {
    id?: string;
    editedOn?: Date;
    editedBy?: UserDto | undefined;
    originalFingerprint?: string | undefined;
    updatedFingerprint?: string | undefined;
    oldDescription?: string | undefined;
    newDescription?: string | undefined;
    originalImpact?: CustomerImpactDto | undefined;
    updatedImpact?: CustomerImpactDto | undefined;
    isSameAsTicketChanged?: boolean | undefined;
    updatedIsSameAsTicket?: boolean | undefined;

    constructor(data?: ICustomerImpactEditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.editedOn = _data["editedOn"] ? new Date(_data["editedOn"].toString()) : <any>undefined;
            this.editedBy = _data["editedBy"] ? UserDto.fromJS(_data["editedBy"]) : <any>undefined;
            this.originalFingerprint = _data["originalFingerprint"];
            this.updatedFingerprint = _data["updatedFingerprint"];
            this.oldDescription = _data["oldDescription"];
            this.newDescription = _data["newDescription"];
            this.originalImpact = _data["originalImpact"] ? CustomerImpactDto.fromJS(_data["originalImpact"]) : <any>undefined;
            this.updatedImpact = _data["updatedImpact"] ? CustomerImpactDto.fromJS(_data["updatedImpact"]) : <any>undefined;
            this.isSameAsTicketChanged = _data["isSameAsTicketChanged"];
            this.updatedIsSameAsTicket = _data["updatedIsSameAsTicket"];
        }
    }

    static fromJS(data: any): CustomerImpactEditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactEditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["editedOn"] = this.editedOn ? this.editedOn.toISOString() : <any>undefined;
        data["editedBy"] = this.editedBy ? this.editedBy.toJSON() : <any>undefined;
        data["originalFingerprint"] = this.originalFingerprint;
        data["updatedFingerprint"] = this.updatedFingerprint;
        data["oldDescription"] = this.oldDescription;
        data["newDescription"] = this.newDescription;
        data["originalImpact"] = this.originalImpact ? this.originalImpact.toJSON() : <any>undefined;
        data["updatedImpact"] = this.updatedImpact ? this.updatedImpact.toJSON() : <any>undefined;
        data["isSameAsTicketChanged"] = this.isSameAsTicketChanged;
        data["updatedIsSameAsTicket"] = this.updatedIsSameAsTicket;
        return data;
    }
}

export interface ICustomerImpactEditEventDto {
    id?: string;
    editedOn?: Date;
    editedBy?: UserDto | undefined;
    originalFingerprint?: string | undefined;
    updatedFingerprint?: string | undefined;
    oldDescription?: string | undefined;
    newDescription?: string | undefined;
    originalImpact?: CustomerImpactDto | undefined;
    updatedImpact?: CustomerImpactDto | undefined;
    isSameAsTicketChanged?: boolean | undefined;
    updatedIsSameAsTicket?: boolean | undefined;
}

export class CustomerImpactEditResultDto implements ICustomerImpactEditResultDto {
    persisted?: boolean;
    synchronized?: boolean;
    editId?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICustomerImpactEditResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.persisted = _data["persisted"];
            this.synchronized = _data["synchronized"];
            this.editId = _data["editId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CustomerImpactEditResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactEditResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["persisted"] = this.persisted;
        data["synchronized"] = this.synchronized;
        data["editId"] = this.editId;
        data["message"] = this.message;
        return data;
    }
}

export interface ICustomerImpactEditResultDto {
    persisted?: boolean;
    synchronized?: boolean;
    editId?: string | undefined;
    message?: string | undefined;
}

export class CustomerImpactEditDto implements ICustomerImpactEditDto {
    version?: string | undefined;
    originalFingerprint?: string | undefined;
    revenue?: number | undefined;
    deviceCount?: number | undefined;
    customerImpactDescription?: string | undefined;
    isSameAsTicket?: boolean | undefined;
    cssCaseNumber?: string | undefined;
    customerName?: string | undefined;
    customerNameSpecified?: boolean;
    customerCountry?: CountryDto | undefined;

    constructor(data?: ICustomerImpactEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.originalFingerprint = _data["originalFingerprint"];
            this.revenue = _data["revenue"];
            this.deviceCount = _data["deviceCount"];
            this.customerImpactDescription = _data["customerImpactDescription"];
            this.isSameAsTicket = _data["isSameAsTicket"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.customerName = _data["customerName"];
            this.customerNameSpecified = _data["customerNameSpecified"];
            this.customerCountry = _data["customerCountry"] ? CountryDto.fromJS(_data["customerCountry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerImpactEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["originalFingerprint"] = this.originalFingerprint;
        data["revenue"] = this.revenue;
        data["deviceCount"] = this.deviceCount;
        data["customerImpactDescription"] = this.customerImpactDescription;
        data["isSameAsTicket"] = this.isSameAsTicket;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["customerName"] = this.customerName;
        data["customerNameSpecified"] = this.customerNameSpecified;
        data["customerCountry"] = this.customerCountry ? this.customerCountry.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerImpactEditDto {
    version?: string | undefined;
    originalFingerprint?: string | undefined;
    revenue?: number | undefined;
    deviceCount?: number | undefined;
    customerImpactDescription?: string | undefined;
    isSameAsTicket?: boolean | undefined;
    cssCaseNumber?: string | undefined;
    customerName?: string | undefined;
    customerNameSpecified?: boolean;
    customerCountry?: CountryDto | undefined;
}

export class AddCustomerImpactDto implements IAddCustomerImpactDto {
    requestId?: string | undefined;
    submissionId?: string | undefined;
    cssCaseNumber?: string | undefined;
    description?: string | undefined;
    confidentialIdentifier?: string | undefined;
    feedbackSource?: string | undefined;
    feedbackSourceDetails?: string | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    submittedViaNewFlow?: boolean;

    constructor(data?: IAddCustomerImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.submissionId = _data["submissionId"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.description = _data["description"];
            this.confidentialIdentifier = _data["confidentialIdentifier"];
            this.feedbackSource = _data["feedbackSource"];
            this.feedbackSourceDetails = _data["feedbackSourceDetails"];
            if (Array.isArray(_data["customerImpacts"])) {
                this.customerImpacts = [] as any;
                for (let item of _data["customerImpacts"])
                    this.customerImpacts!.push(CustomerImpactDto.fromJS(item));
            }
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
            this.submittedViaNewFlow = _data["submittedViaNewFlow"];
        }
    }

    static fromJS(data: any): AddCustomerImpactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerImpactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["submissionId"] = this.submissionId;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["description"] = this.description;
        data["confidentialIdentifier"] = this.confidentialIdentifier;
        data["feedbackSource"] = this.feedbackSource;
        data["feedbackSourceDetails"] = this.feedbackSourceDetails;
        if (Array.isArray(this.customerImpacts)) {
            data["customerImpacts"] = [];
            for (let item of this.customerImpacts)
                data["customerImpacts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        data["submittedViaNewFlow"] = this.submittedViaNewFlow;
        return data;
    }
}

export interface IAddCustomerImpactDto {
    requestId?: string | undefined;
    submissionId?: string | undefined;
    cssCaseNumber?: string | undefined;
    description?: string | undefined;
    confidentialIdentifier?: string | undefined;
    feedbackSource?: string | undefined;
    feedbackSourceDetails?: string | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    submittedViaNewFlow?: boolean;
}

export class AddWatcherDto implements IAddWatcherDto {
    users?: UserDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    requestId?: string | undefined;

    constructor(data?: IAddWatcherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): AddWatcherDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddWatcherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IAddWatcherDto {
    users?: UserDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    requestId?: string | undefined;
}

export class EnumLookUp implements IEnumLookUp {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEnumLookUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumLookUp {
        data = typeof data === 'object' ? data : {};
        let result = new EnumLookUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnumLookUp {
    id?: number;
    name?: string | undefined;
}

export class CreateCssReviewRequestDto extends BaseRequestDto implements ICreateCssReviewRequestDto {
    cssCaseNumber?: string | undefined;
    summary?: string | undefined;
    customerEmail?: string | undefined;

    constructor(data?: ICreateCssReviewRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.summary = _data["summary"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static override fromJS(data: any): CreateCssReviewRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCssReviewRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["summary"] = this.summary;
        data["customerEmail"] = this.customerEmail;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCssReviewRequestDto extends IBaseRequestDto {
    cssCaseNumber?: string | undefined;
    summary?: string | undefined;
    customerEmail?: string | undefined;
}

export class CssReviewRequestDto extends CreateCssReviewRequestDto implements ICssReviewRequestDto {
    productCategory?: ProductCategory | undefined;
    taskStatus?: TaskStatus | undefined;
    bugInformations?: BugInformations[] | undefined;

    constructor(data?: ICssReviewRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformations.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CssReviewRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CssReviewRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICssReviewRequestDto extends ICreateCssReviewRequestDto {
    productCategory?: ProductCategory | undefined;
    taskStatus?: TaskStatus | undefined;
    bugInformations?: BugInformations[] | undefined;
}

export class EditCssReviewRequestDto extends EditRequestDto implements IEditCssReviewRequestDto {
    productCategory?: ProductCategory | undefined;
    whyThisDateIsImportant?: string | undefined;
    cssCaseNumber?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    bugInformations?: BugInformations[] | undefined;

    constructor(data?: IEditCssReviewRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformations.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditCssReviewRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCssReviewRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEditCssReviewRequestDto extends IEditRequestDto {
    productCategory?: ProductCategory | undefined;
    whyThisDateIsImportant?: string | undefined;
    cssCaseNumber?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    bugInformations?: BugInformations[] | undefined;
}

export class PaginatedListOfCssReviewRequestDto implements IPaginatedListOfCssReviewRequestDto {
    items?: CssReviewRequestDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCssReviewRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CssReviewRequestDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCssReviewRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCssReviewRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCssReviewRequestDto {
    items?: CssReviewRequestDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AddAttachmentDto implements IAddAttachmentDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IAddAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAddAttachmentDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    attachments?: AttachmentDto[] | undefined;
}

export enum EntityType {
    HelpRequest = 1,
    Feedback = 2,
    Article = 3,
    Comment = 4,
    Report = 5,
    Status = 6,
}

export enum Portal {
    User = 1,
    Admin = 2,
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    UnprocessableContent = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export class UpdateClassificationDto implements IUpdateClassificationDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    id?: string;

    constructor(data?: IUpdateClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateClassificationDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    id?: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class CssApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCssApiException = true;

    static isCssApiException(obj: any): obj is CssApiException {
        return obj.isCssApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CssApiException(message, status, response, headers, null);
}

// Adds Authorization header to requests made by the nswag generated clients

export class ApiError extends Error {
    status: number;
    statusText: string;
    detail: any;

    constructor(status: number, statusText: string, detail?: any) {
        super(`${status} ${statusText}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.detail = detail;
    }

    static isApiError(obj: any): obj is ApiError {
        return obj instanceof ApiError;
    }
}